import { Injectable } from '@angular/core';
import { RequestConfigImplementation, REQUEST_METHODS, HTTPWrapperContext, XHR_STRATEGIES } from '@ptl/xhr';
import { IndividualDrugItem } from 'src/app/shared/interfaces/drug-autocomplete-item.interface';
import { HttpHeaders } from '@angular/common/http';
import { BrandingConfigurationService } from '@ptl/brand';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { EffectiveDateStateStructure } from '../../../../shared/components/configs/interfaces/effective-date.state-structure.interface';

@Injectable({
  providedIn: 'root'
})
export class IndividualMedInfoService {
  constructor(
    private httpClient: HTTPWrapperContext,
    private brandService: BrandingConfigurationService,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  // The autocomplete search only pulls down possible drug search terms. Once selected, then you
  // can execute the "searchByName" with the full name of the drug to pull down ALL available drugs
  autocompleteByName(searchString: string): Promise<IndividualDrugItem[]> {
    const effectiveDateState: EffectiveDateStateStructure = this.reducerUtilityService.getReducerFromApplicationState('EffectiveDate');

    let payload = {
        year: effectiveDateState?.effectiveDateYear,
        searchtext: searchString,
        planids:'' // always empty
    };

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/sxesvc/api/v1/druglookup/autocomplete',
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded()
      }),
      POST_OR_PUT_PAYLOAD: payload,
      strategyConfigs: { forceModernUrl: true }
    });
    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_PRE_PASS);
    return this.httpClient.makeRequest<IndividualDrugItem[]>(requestConfigImplementation);
  }

  // Search for a specific drug. fullDrugName cannot be a partial name, as the name suggests
  searchByName(fullDrugName: string): Promise<IndividualDrugItem[]> {
    const effectiveDateState: EffectiveDateStateStructure = this.reducerUtilityService.getReducerFromApplicationState('EffectiveDate');

    let payload = {
        year: effectiveDateState?.effectiveDateYear,
        searchtext: fullDrugName,
        planids:'' // always empty
    };

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/sxesvc/api/v1/druglookup/',
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded()
      }),
      POST_OR_PUT_PAYLOAD: payload,
      strategyConfigs: { forceModernUrl: true }
    });
    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_PRE_PASS);
    return this.httpClient.makeRequest<IndividualDrugItem[]>(requestConfigImplementation);
  }
}
